import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { map } from "rxjs";
import { PlanService } from "../services/plan.service";
import { IPlan } from "@app/shared/payment/interfaces/plan.interfaces";

export const getAllPlansResolver: ResolveFn<IPlan[]> = route => {
  const planService = inject(PlanService);
  const options = route.data["getAllPlansOptions"];
  const dataShape = options?.["dataShape"];
  return planService.getAll(dataShape).pipe(map(res => res.data["allPlans"]));
};
